// extracted by mini-css-extract-plugin
module.exports = {"Header":"header_Header__3PnCL","logo":"header_logo__3BVhg","searchUsers":"header_searchUsers__2DfJg","UserInfoBlock":"header_UserInfoBlock__1e5-m"};